import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/newCreditCard";
import Loading from "@/atomic/atoms/Loading";
import LoadingOverlay from "@/atomic/atoms/LoadingOverlay";
import { InputMask } from "@react-input/mask";
import Modal from "@/atomic/atoms/Modal";
import Button from "@/atomic/atoms/Button";
import { useState, useEffect } from "react";

export default function NewCreditCardView({
  isLoading,
  goBack,
  isDisabled,
  success,
  isVisibleModal,
  toggleModal,
  isVisibleConfirmationModal,
  isVisibleDisableAutoPaymentModal,
  handleConfirmAutoPayment,
  handleCancelAutoPayment,
  handleAutoPaymentChange,
  handleConfirmDisableAutoPaymentModal,
  handleCancelDisableAutoPaymentModal,
  errorChangeMethod,
  handleSubmit,
  register,
  errors,
  watch,
  isAutoPaymentEnabled = true,
  isEditing = false,
  initialAutoPaymentState = false,
  captchaName = "mtcaptcha-new-credit-card-0",
  isCaptchaVerified = false,
  isLoadingCaptchaFlag = false,
}: PropsView) {
  const [showCaptcha, setShowCaptcha] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowCaptcha(true);
    }, 100);

    return () => {
      clearTimeout(timer);
      setShowCaptcha(false);
    };
  }, [captchaName]);

  return (
    <div className="relative flex flex-1 flex-col w-full">
      <Header
        title="Pagamento"
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-2 z-10 w-full flex justify-center h-full text-black h-form bg-white">
        <form className="h-full flex flex-col justify-between w-[calc(480px)]" onSubmit={handleSubmit}>
          <div className="pb-[calc(120px)]">
            <h2 className="mt-6 text-black text-xl">Cartão de crédito</h2>
            <div className="flex flex-col justify-center">
              <InputMask
                {...register("number")}
                name="number"
                required
                type="text"
                inputMode="numeric"
                mask="____ ____ ____ ______"
                replacement={{ _: /\d/ }}
                placeholder="Número do cartão"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              {errors.number && (
                <span className="text-red-500 text-xs">{errors.number.message as string}</span>
              )}
              <input
                {...register("name")}
                required
                type="text"
                name="name"
                placeholder="Nome no cartão"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              {errors.name && (
                <span className="text-red-500 text-xs">{errors.name.message as string}</span>
              )}
              <InputMask
                {...register("expiration")}
                name="expiration"
                required
                type="text"
                inputMode="numeric"
                mask="__/____"
                replacement={{ _: /\d/ }}
                placeholder="Vencimento: MM/AAAA"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              {errors.expiration && (
                <span className="text-red-500 text-xs">{errors.expiration.message as string}</span>
              )}
              {isAutoPaymentEnabled && (
                <div className="flex flex-row items-center justify-center mt-4 w-full">
                  <input 
                    {...register("autoPayment")}
                    type="checkbox" 
                    name="autoPayment"
                    className="w-6 h-6 accent-black mr-2"
                    onChange={handleAutoPaymentChange}
                  />
                  <p className="w-full text-sm text-black">Ativar pagamento direto no cartão cadastrado</p>
                </div>
              )}
            </div>

            {showCaptcha && (
              <div className="w-full mb-4 flex justify-center relative">
                <LoadingOverlay isLoading={isLoadingCaptchaFlag} bgColor="bg-white/50" />                    
                <div
                  className="mtcaptcha"
                  id={captchaName}
                  data-callback="onCaptchaSuccess"
                ></div>
              </div>
            )}

          </div>
          <Button 
            className="rounded-xl bg-primary text-white"
            title="Salvar cartão"
            isDisabled={isDisabled || !isCaptchaVerified}
            type="submit"
          />
        </form>
      </main>
      {errorChangeMethod && isVisibleModal && <Modal
        title="Atenção!"
        message="Não foi possível adicionar seu cartão de crédito. Quer tentar novamente?"
        actionMessage="Sim"
        actionSecondMessage="Não"
        action={() => {
          toggleModal();
          handleSubmit();
        }}
        actionSecond={toggleModal}
      />}
      {success && isVisibleModal && <Modal
        iconTitle={
          <img
            src={"/icon-checked.png"}
            width={62}
            height={62}
            alt="ícone sucesso"
            className="mt-6"
          />
        }
        title="Sucesso!"
        message="Seu cartão foi cadastrado."
        actionMessage="Ok"
        action={() => {
          toggleModal();
          goBack();
        }}
        actionSecond={() => {
          toggleModal();
          goBack();
        }}
      />}
      {isVisibleConfirmationModal && isAutoPaymentEnabled && <Modal
        title="Atenção!"
        messageElement={
          <div className="text-center">
            <p className="text-sm text-black mb-4">
              Todas as novas passagens serão debitadas no cartão informado.
            </p>
            <p className="text-sm text-black mb-4">
              Tem certeza que deseja ativar o pagamento direto no cartão:
            </p>
            <p className="text-sm text-black font-mono">
              **** **** **** {watch("number")?.replace(/\D/g, "").slice(-4) || '0000'}
            </p>
          </div>
        }
        actionMessage="Sim"
        action={handleConfirmAutoPayment}
        actionSecondMessage="Não"
        actionSecond={handleCancelAutoPayment}
      />}
      {isVisibleDisableAutoPaymentModal && isAutoPaymentEnabled && isEditing && initialAutoPaymentState && !success && <Modal
        title="Atenção!"
        messageElement={
          <div className="text-center">
            Tem certeza que deseja desativar o pagamento direto no cartão cadastrado?
          </div>
        }
        actionMessage="Sim"
        action={handleConfirmDisableAutoPaymentModal}
        actionSecondMessage="Não"
        actionSecond={handleCancelDisableAutoPaymentModal}
      />}
      {isLoading && <Loading />}
    </div>
  );
}
